/**
 * Chooses which sitewide popup to show:
 *  - "popup-welcome10-trigger"   -> 10%-off first-order popup (default / not yet redeemed)
 *  - "popup-earlyaccess-trigger" -> early-access / "Something's coming" popup (already redeemed WELCOME10)
 *
 * The "already redeemed" state is set by a first-party cookie named below. That cookie is written
 * by the Custom Pixel (Shopify Admin > Settings > Customer events) after a checkout_completed event
 * that used the WELCOME10 discount code -- see the setup instructions provided alongside this file.
 *
 * Display frequency: shows once per browser session. Popup.js's own manual-trigger click handler
 * bypasses its normal display-limit check (that check only applies to delay/scroll/exit triggers),
 * so this file tracks "already shown this session" itself via sessionStorage, which clears when the
 * tab/browser closes -- next session, the popup is eligible to show again.
 */
(function () {
  var REDEEMED_COOKIE = 'bl_redeemed_10off';
  var SESSION_FLAG = 'bl_popup_shown_session';

  function hasCookie(name) {
    return document.cookie.indexOf(name + '=') !== -1;
  }

  function alreadyShownThisSession() {
    try {
      return sessionStorage.getItem(SESSION_FLAG) === '1';
    } catch (err) {
      // Storage unavailable (e.g. some private-browsing modes) -- fail open
      // rather than silently blocking the popup forever.
      return false;
    }
  }

  function markShownThisSession() {
    try {
      sessionStorage.setItem(SESSION_FLAG, '1');
    } catch (err) {
      // Ignore -- worst case the popup can show more than once this session.
    }
  }

  function fireTrigger() {
    if (alreadyShownThisSession()) {
      return;
    }

    var hasRedeemed = hasCookie(REDEEMED_COOKIE);
    var triggerId = hasRedeemed ? 'popup-earlyaccess-trigger' : 'popup-welcome10-trigger';
    var el = document.getElementById(triggerId);
    if (el) {
      markShownThisSession();
      el.click();
    }
  }

  window.addEventListener('load', function () {
    // Small delay so popup.js (loaded just before this file) has finished
    // binding its delegated click handlers before we synthesize a click.
    setTimeout(fireTrigger, 1000);
  });
})();
